<!-- <p>calendar-details works!</p> -->
<div #divHeight class="calendar-details-container">
  <mat-card class="calendar-details-card">
    <mat-card-header
      [ngClass]="{
        'calendar-details-card-header':
          screenInfo == ScreenType.Desktop || screenInfo == ScreenType.Tablet,
        'calendar-details-card-header-mobile': screenInfo == ScreenType.Mobile
      }"
      >Summary of {{ selectedDate | date }}</mat-card-header
    ><mat-divider></mat-divider>
    <mat-card-content class="calendar-details-card-content">
      <app-visitor-summary
        [chartData]="chartData"
        [screen]="screenInfo"
      ></app-visitor-summary>
      <!-- <section #table class="table-container">
        <table mat-table [dataSource]="dataSource" class="timeslot-table">
          <ng-container matColumnDef="time">
            <th mat-header-cell *matHeaderCellDef>Time</th>
            <td mat-cell *matCellDef="let element">{{ element.time }}</td>
          </ng-container>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>Time</th>
            <td mat-cell *matCellDef="let element">
              {{ element.timeslotIndex }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </section> -->
    </mat-card-content>
    <!-- <mat-card-actions class="calendar-details-card-actions"></mat-card-actions> -->
  </mat-card>
</div>
